module.exports = __webpack_public_path__ + "img/joie.ec23ad46.png";